import { render, staticRenderFns } from "./UpdateIcon.vue?vue&type=template&id=c262ba3e&"
import script from "./UpdateIcon.vue?vue&type=script&lang=ts&"
export * from "./UpdateIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports